<p class="section-description">
  Edge-case data sets that reproduce the known Issues-screen bugs, so the dedup and name-highlight fixes can be verified
  visually.
</p>

<ng-container *ngIf="application; else needAppForScenarios">
  <!-- Scenario 1 — duplicate rows -->
  <h3 class="scenario-heading">Duplicate resource rows</h3>
  <div class="notice-info">
    <svg lucideInfo></svg>
    <p>
      The same resource (identical ARN) is raised three times for one problem. The backend appends issues without
      deduping, so pre-fix this listed the resource on three separate rows. The fix collapses same-ARN repeats within a
      sub-group, so it should now show a <strong>single</strong> row.
    </p>
  </div>
  <issues-view [issues]="duplicateRowsIssues" [sync-pair]="syncPair" [application]="application"></issues-view>

  <!-- Scenario 2 — tripled name -->
  <h3 class="scenario-heading">Identical names (tripled-name highlight)</h3>
  <div class="notice-info">
    <svg lucideInfo></svg>
    <p>
      Two distinct resources (different ARNs) share one display name. The diff-highlight finds a common prefix and
      suffix that overlap on identical names, so pre-fix the name rendered concatenated/tripled. Dedup leaves both rows
      (ARNs differ); the highlight clamp should render each name
      <strong>once</strong>. Use the per-row <strong>ARN</strong> button to tell the two rows apart.
    </p>
  </div>
  <issues-view [issues]="tripledNameIssues" [sync-pair]="syncPair" [application]="application"></issues-view>
</ng-container>
<ng-template #needAppForScenarios>
  <div class="notice-info">
    <svg lucideInfo></svg>
    <p>No application is loaded for this account, so the issues-view scenarios can't render.</p>
  </div>
</ng-template>
